import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { ILegalSettings } from '../legal.model';

/**
 * I testi legali dell'agenzia che incassa un dato itinerario, per il viaggiatore
 * autenticato che sta per pagarlo.
 *
 * I testi stanno in user_public_profile, che il viaggiatore potrebbe anche leggere da
 * solo: la RPC esiste per non fargli risalire a mano itinerario -> travel request ->
 * advisor -> eventuale agenzia, cioe' per non duplicare nel frontend la regola di
 * ownership. Il permesso e' quello di can_view_itinerary.
 * Il cliente anonimo dello shared link non passa di qui — riceve i testi dentro
 * get-shared-itinerary.
 */
export const useItineraryLegalSettings = (itineraryId?: string, enabled = true) => {
  const query = useQuery<ILegalSettings | null>({
    queryKey: ['itinerary-legal-settings', itineraryId],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_itinerary_legal_settings' as any, {
        p_itinerary_id: itineraryId,
      });
      if (error) throw error;
      return (data ?? null) as ILegalSettings | null;
    },
    enabled: !!itineraryId && enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return { legal: query.data ?? null, isLoading: query.isLoading };
};
